export default "__VITE_ASSET__DY0BEk4l__"